import React from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';

const Gallery = ({ images }) => {
  if (!images || !images.length) {
    return null;
  }
  const items =
    images &&
    images.map((image) => ({
      original: `/uploads/gallery/${image}`,
      thumbnail: `/uploads/gallery/${image}`,
    }));

  return (
    <section className="gallery">
      <h2 className="container">Gallery</h2>

      <ImageGallery
        items={items}
        slideInterval={2000}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets
      />
    </section>
  );
};

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
};

export default Gallery;
